export default function HeaderContent({ styles }) {
  return (
    <div style={styles.mainDiv}>
      <div style={styles.imgContainer}>
        <img
          src={"/BIR.png"}
          className="img-fluid"
          style={{ maxWidth: "90px", maxHeight: "70px", marginRight: "5px" }}
        />
      </div>
      <div>
        <p style={{ ...styles.h5, ...styles.specifiedMargin }}>
          BUREAU OF IMMIGRATION
        </p>
        <p style={styles.specifiedMargin}>
          Magallanes Drive, Intramuros 1002 Manila
        </p>
        <p style={styles.specifiedMargin}>
          COMPENSATION AND EMPLOYEE BENEFITS SECTION
        </p>
        <p style={{ ...styles.specifiedMargin, ...styles.italic }}>
          Tel. No. (02)8465-2400 loc.320
        </p>
        <p style={{ ...styles.specifiedMargin, ...styles.italic }}>
          hrdd.cebsection@immigration.gov.ph
        </p>
      </div>
      <div style={styles.imgContainer}>
        <img
          src={"/Bagong-Pilipinas-Logo.png"}
          className="img-fluid"
          style={{ maxWidth: "110px", maxHeight: "85px" }}
        />
      </div>
    </div>
  );
}
